export default "__VITE_ASSET__bd545d24__"